export default __webpack_public_path__ + "static/logo-android-dark-e2ae6a36bf91188b066bb97f2bb48adb.svg";